/**
 * Feed home column width — ContentView → FeedList scroll padding → tile/hero outer margin.
 * Keep in sync with ContentView.tsx, FeedList contentContainerStyle, FeedTile, HeroCarousel.native.
 */
export const CONTENT_VIEW_PADDING_HORIZONTAL = 16;
export const FEED_LIST_CONTENT_PADDING_HORIZONTAL = 8;
/** Matches FeedTile container marginHorizontal — native hero uses the same inset. */
export const FEED_ITEM_OUTER_MARGIN_HORIZONTAL = 8;

/**
 * Usable width for feed tiles and native HeroCarousel (same left/right inset from the window).
 */
export function getFeedItemColumnWidth(windowWidth: number): number {
  return (
    windowWidth -
    CONTENT_VIEW_PADDING_HORIZONTAL * 2 -
    FEED_LIST_CONTENT_PADDING_HORIZONTAL * 2 -
    FEED_ITEM_OUTER_MARGIN_HORIZONTAL * 2
  );
}
